(function (window, document, $) {
    'use strict';

    var getPositionText = function (target) {
        return $('#page-subnav-desktop').find('[href="'+ target +'"]').text();
    };

    $(function () {
        $(window).on('activate.bs.scrollspy', function (evt, obj) {
            var positionText = getPositionText(obj.relatedTarget);
            $('#nav-inpage-position').html(positionText);

            $('#page-subnav-mobile').find('.nav-item.active').removeClass('active');
            $('#page-subnav-mobile').find('[href="'+ obj.relatedTarget +'"]').parent().addClass('active');
        });

        $('body').scrollspy({
            target: '#page-subnav-desktop',
            offset: 10
        });

        var mobileNav = $('#page-subnav-mobile');
        if (mobileNav.length === 1) {
            mobileNav.on('click', '.nav-link', function (evt) {
                $(evt.delegateTarget).collapse('hide');
            });
        }
    });

}(window, document, jQuery));